import { toPlainText } from "next-sanity";

export type SanityBlockContent = Parameters<typeof toPlainText>[0] | string;

// If the title field is a sanity block content field, we need to convert it to plain text.
export const sanityBlockContentToString = (title: string | SanityBlockContent) => (
    typeof title === 'string' ? title : toPlainText(title)
);
